import { render, staticRenderFns } from "./refund_confirm.vue?vue&type=template&id=32e8941b&scoped=true"
import script from "./refund_confirm.vue?vue&type=script&lang=js"
export * from "./refund_confirm.vue?vue&type=script&lang=js"
import style0 from "./refund_confirm.vue?vue&type=style&index=0&id=32e8941b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8941b",
  null
  
)

export default component.exports